import React, {  } from 'react';
import ProfileForm from '../Forms/ProfileForm';

const MyProfile = (props) => {
    return (
        <>
            <div className="kt-portlet">
                <div className="kt-portlet__head kt-portlet__head--lg">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-heading kt-heading--lg">Profile</h3>
                    </div>
                </div>
   
                <div className="kt-portlet__body">
                    <ProfileForm {...props.user}></ProfileForm>
                </div>

            </div>
        </>
    );
}
export default MyProfile;